import dayjs from "dayjs";
import i18n from "features/parent/i18n";
import { AIChatSession } from "features/parent/types";

interface AIChatSessionCardProps {
  session: AIChatSession;
  onClick: () => void;
}

// 日付フォーマット（日付のみ）
const formatDateShort = (dateString: string) => {
  return dayjs(dateString).format("YYYY-MM-DD");
};

export const AIChatSessionCard = ({ session, onClick }: AIChatSessionCardProps) => {
  return (
    <div
      className="bg-white rounded-[16px] py-4 px-5 cursor-pointer transition-all shadow-sm border border-outline hover:shadow-md"
      onClick={onClick}
    >
      {/* 1行目: 日付 + メッセージ数 */}
      <div className="flex-row-el items-center justify-between mb-2">
        <span className="text-[19px] text-gray2-100">{formatDateShort(session.created_at)}</span>
        <span className="flex-row-el items-center gap-1 text-[18px] text-gray2-100">
          <span className="material-symbols-outlined text-[21px]">chat</span>
          {i18n.t("MSG_PARENT_PAGE_AI_CHAT_MESSAGE_COUNT", { count: session.message_count })}
        </span>
      </div>

      {/* 2行目: セッションタイトル（truncate） */}
      <div className="text-[21px] text-textcolor-black leading-[1.5] truncate">
        {session.title || i18n.t("MSG_PARENT_PAGE_AI_CHAT_NO_TITLE")}
      </div>

      {/* 3行目: 最後のメッセージ（truncate） */}
      {session.last_message && (
        <div className="text-[18px] text-gray2-100 leading-[1.5] truncate mt-1">
          {session.last_message.content}
        </div>
      )}
    </div>
  );
};
